import { useState, useEffect } from 'react';
import { menuApi, MenuItem } from '../api/menuApi';

export type { MenuItem };

export const useMenu = () => {
  const [menu, setMenu] = useState<MenuItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadMenu = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await menuApi.getUserMenu();
      setMenu(response.menu);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error loading menu');
      console.error('Error loading menu:', err);
    } finally {
      setLoading(false);
    }
  };

  const checkPermission = async (functionCode: string, action: string): Promise<boolean> => {
    return await menuApi.checkPermission(functionCode, action);
  };

  const checkFunctionAccess = async (functionCode: string): Promise<boolean> => {
    return await menuApi.checkFunctionAccess(functionCode);
  };

  useEffect(() => {
    loadMenu();
  }, []);

  return {
    menu,
    loading,
    error,
    reloadMenu: loadMenu,
    checkPermission,
    checkFunctionAccess,
  };
};

export const useMobileMenu = () => {
  const [menu, setMenu] = useState<MenuItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadMobileMenu = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await menuApi.getMobileMenu();
      setMenu(response.menu);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error loading mobile menu');
      console.error('Error loading mobile menu:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMobileMenu();
  }, []);

  return {
    menu,
    loading,
    error,
    reloadMenu: loadMobileMenu,
  };
}; 